import { render, staticRenderFns } from "./ForgotPasswordSuccess.vue?vue&type=template&id=3204c3f9&scoped=true&"
import script from "./ForgotPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordSuccess.vue?vue&type=style&index=0&id=3204c3f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3204c3f9",
  null
  
)

export default component.exports